import { render, staticRenderFns } from "./quiz-component.vue?vue&type=template&id=2a2540ac&"
import script from "./quiz-component.vue?vue&type=script&lang=ts&"
export * from "./quiz-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports